<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import Table from "@/components/standard/PrevencionEmergenciasActas/components/PromotionTable";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import prevencionEmergenciasActasAPI from "../../../services/standards/prevencionEmergenciasActas/prevencionEmergenciasActasAPI";
import PromotionPagination from "../../../components/standard/PrevencionEmergenciasActas/components/PromotionPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "5.1.1 Plan de prevención, preparación y respuesta ante emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    PromotionPagination,
  },
  data() {
    return {
      title: "5.1.1 Plan de prevención, preparación y respuesta ante emergencias",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "5.1.1 Plan de prevención, preparación y respuesta ante emergencias",
          active: true,
        },
      ],
      lista: [],
      item: null,
      loading: true,
      search: '',
      itemData: null,
      file: null,
      lastId: 1,
      deleteCount: 0,
      program: {
        file: "datos",
        emergency_plan_id: this.$route.params.id,
      },
      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  validations: {
    program: {
      file: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(51)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 51)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/1/Prevencion-emergencias-actas/Acta de constitucion Comite Emergencias.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
    async print2() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/1/Prevencion-emergencias-actas/Acta de constitucion Coordinadores Evacuacion.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/5.1.1/${this.$route.params.id}/actas/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/5.1.1/${this.$route.params.id}/actas/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.program.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      prevencionEmergenciasActasAPI.get(this.$route.params.id)
        .then((response) => {
          this.lista = response.data.data;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    deleteActa(id) {
      prevencionEmergenciasActasAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 51,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        const data = {
          file: this.program.file,
          emergency_plan_id: this.program.emergency_plan_id,
        };
        prevencionEmergenciasActasAPI.save(data)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 51,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(35, 51, true);
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000);
                window.location.reload();
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <CheckModal>
                    <p class="text-justify">
                      Se debe contar con un plan de prevención, preparación y respuesta ante emergencias y programar su
                      divulgación en el ítem 1.2.1.
                    </p>
                    <p class="text-justify">
                      Contar con los planos de las instalaciones que identifican áreas y salidas de emergencia y
                      verificar si existe la debida señalización de la empresa.
                    </p>
                    <p class="text-justify">
                      Subir los soportes que evidencien la realización de los simulacros y análisis de los mismos y
                      validar que las recomendaciones emitidas con base en dicho análisis hayan sido tenidas en cuenta
                      en el mejoramiento del plan de emergencias.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 " id="tooltipp">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltipp" placement="left">Volver</b-tooltip>
                </div>
              </div>
              <div class="row">
                <div class="col-6"></div>
              </div>

              <div class="row mt-2 mb-2">
                <div class="col-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Acta de constitución Comité Emergencias
                  </button>
                  <b-tooltip target="tooltip" placement="top">
                    Descargar acta de constitución Comité Emergencias
                  </b-tooltip>
                </div>
                <div class="col-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="print2" class="btn btn-primary mx-1" id="tooltip1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Acta de constitución Coordinadores Evacuación
                  </button>
                  <b-tooltip target="tooltip1" placement="top">
                    Descargar acta de constitución Coordinadores Evacuación
                  </b-tooltip>
                </div>

              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <b-form-group class="col-md-12 px-2" label="Subir acta" label-for="file">
                  <b-form-file :disabled="!allowAccess() || !getRole('Crear')" type="file" id="file" ref="file"
                    name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                    drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                  </b-form-file>
                  <div v-if="submitted && $v.program.file.$error">
                    <small v-if="!$v.program.file.required" class="text-danger">
                      <b>El acta es requerida</b>
                    </small>
                  </div>
                </b-form-group>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>
              </form>
              <hr />
              <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                <thead class="table-active">
                  <tr>
                    <th scope="col" class="text-center align-middle">
                      Fecha
                    </th>
                    <th scope="col" class="text-center align-middle">
                      Descripcion del archivo
                    </th>
                    <th scope="col" class="text-center align-middle">
                      Ver archivo
                    </th>
                    <th scope="col" class="text-center align-middle">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="item in lista" :key="item.id">
                    <td class="text-center align-middle">
                      {{ dateConvert(item.created_at) }}
                    </td>
                    <td class="text-center align-middle">
                      Acta de constitución
                    </td>
                    <td class="text-center align-middle">
                      <div v-if="item.file === null">
                        <h6>No hay archivo disponible
                        </h6>
                      </div>
                      <div v-else>
                        <button :disabled="!allowAccess()"
                          style=" background-color: transparent !important; border: none;" type="button"
                          @click="gotoDigitalOcean(`${item.file}`)"> <i class="mdi mdi-cloud-download"></i>
                        </button>
                      </div>
                    </td>
                    <td class="text-center align-middle">
                      <div class="col-sm-12">
                        <b-dropdown variant="primary" :disabled="!allowAccess()">
                          <template v-slot:button-content>
                            <i class="mdi mdi-eye"></i>
                          </template>
                          <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                            :to="{ path: `/forms/estandares/prevencion-emergencias-actas-editar/${item.id}` }">
                            Editar
                          </b-dropdown-item>
                          <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                            v-on:click="deleteActa(item.id)">Eliminar</b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <PromotionPagination :companyID="companyID" ref="paginator" :search="search"
                @fetch="(items) => (lista = items)" />
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
